import type { ReactNode } from 'react'
import type { TemplateCategory, TemplateTag } from '@/lib/cms'

import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { Navbar } from '@/components/layout/navbar'
import { Footer } from '@/components/layout/footer'
import { ScrollTrigger } from '@/lib/gsap'

interface LayoutProps {
    children: ReactNode
    topCategories?: TemplateCategory[]
    topTags?: TemplateTag[]
}

export const Layout = ({ children, topCategories, topTags }: LayoutProps): ReactNode => {
    const router = useRouter()

    // After a client-side navigation the page height changes but no scroll fires, so
    // scroll-reveal triggers (notably the footer) can stay stuck hidden. Re-measure them.
    useEffect(() => {
        const onDone = () => requestAnimationFrame(() => ScrollTrigger.refresh())

        router.events.on('routeChangeComplete', onDone)

        return () => router.events.off('routeChangeComplete', onDone)
    }, [router.events])

    return (
        <div className='page-wrap'>
            <Navbar />
            <main>{children}</main>
            <Footer topCategories={topCategories} topTags={topTags} />
        </div>
    )
}
